var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegendScore3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 43,
    viewBox: "0 0 116 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5104_4200",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H116V42.5H0V0.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2H116V-1H0V2ZM116 41H0V44H116V41Z",
    fill: "#00ED50",
    mask: "url(#path-1-inside-1_5104_4200)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegendScore3);
export default __webpack_public_path__ + "static/media/legend-score-3.6c93fd7ebd640e3254e931c0f2e57d1d.svg";
export { ForwardRef as ReactComponent };